var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 668,
    height: 670,
    viewBox: "0 0 668 670",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-44 348.395 315.592)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#8200DF",
    cx: 321.5,
    cy: 321.616,
    r: 321.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 .116c-127.596 3.07-223.132 61.07-286.608 174H607.16C544.65 55.046 449.596-2.954 322 .116zm321 341H.844c.616 28.261 5.787 56.261 15.511 84 9.725 27.738 24.055 55.405 42.988 83H583.48c16.083-19.046 30.024-46.713 41.822-83 11.798-36.287 17.697-64.287 17.697-84z",
    fill: "#FF620A"
  }))));
}

export default SvgIconBrand;